<template>
  <div>
    <div><input v-model='days' @keyup.enter="enterClicked()"/></div>
    <div class="row">
      <div class="col-sm-6 graph-box">
        <BrowserTypes :data=browser.data.browser></BrowserTypes>
      </div>
      <div class="col-sm-6 graph-box">
        <OSTypes :data=browser.data.os></OSTypes>
      </div>
    </div>
  </div>
</template>

<script>
import BrowserTypes from '@/components/BrowserTypes.vue'
import OSTypes from '@/components/OsTypes.vue'
import axios from 'axios';

export default {
  data: function() {return {
    days: 45,
    usagers: {data: []},
    activite: {data: []},
    lhinActivity: {data: []},
    hspActivity: {data: []},
    browser: {data: {browser: [], os: []}}
  }},

  name: 'Fureteurs',
  components: {
    BrowserTypes,
    OSTypes
  },
  methods: {
    enterClicked: function() {
      this.refresh()
    },
    refresh: function() {
      axios
        .get(this.$root.$data.server_base + '/api/on/browser_types.php',
          { params: {days: this.days} })
        .then(response => (this.browser = response))
    }
  },
  mounted () {
    this.refresh()
  }
}
</script>

<style>
  div.graph {
    display: inline-block;
    width: 46%;
    background-color: #f5f5f5;
    border: 1px #c5c5c5 solid;
    border-radius: 5px;
    margin: 5px;
    padding: 15px;
  }
  .graph-box {
    /* background-color: #f5f5f5; */
    /* padding: 5px; */
  }
</style>
